import EXTRAS from "../../utils/extras";

// Shows the dashboard button if the dashboard module is enabled and the node
// has dashboards or the hub has dashboards and the node has ShowHubDashboards set to true
export const showNodeDashboardsButton = (moduleConfigs, node, hub) => {
  if (moduleConfigs.modules.includes("dashboard") && node) {
    const nodeDashboards =
      node.itemContainers?.dashboard?.uncategorizedDashboards?.concat(
        node.itemContainers?.dashboard?.categorizedDashboards
      ) ?? [];
    const showHubDashboards = EXTRAS.parse(node.extras)?.ShowHubDashboards ?? false;
    const hubDashboards = showHubDashboards
      ? (hub?.itemContainers?.dashboard?.uncategorizedDashboards?.concat(
          hub?.itemContainers?.dashboard?.categorizedDashboards
        ) ?? [])
      : [];
    return nodeDashboards.length > 0 || hubDashboards.length > 0;
  } else {
    return false;
  }
};

export const HEADER_BUTTON_VIEW_MODE_ICON = "HEADER_BUTTON_VIEW_MODE_ICON";
export const HEADER_BUTTON_VIEW_MODE_TEXT = "HEADER_BUTTON_VIEW_MODE_TEXT";
export const HEADER_BUTTON_VIEW_MODE_ICONTEXT = "HEADER_BUTTON_VIEW_MODE_ICONTEXT";
